export default __webpack_public_path__ + "static/media/miniuser.32b8ae69.svg";